module["exports"] = [
  "#####",
  "### ##",
  "###-##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/address/postcode.js
// module id = 204
// module chunks = 0